import { cn } from './cn';

/**
 * DESIGN.md › stat-card: a white 20px-radius card with an
 * emoji, a `stat-value` value and a caption — four of them sit in the tinted Overview card.
 * Text arrives translated; the emoji is part of the design.
 */
export function StatCard({
  emoji,
  value,
  caption,
  className,
}: {
  emoji: string;
  value: string;
  caption: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex min-w-0 flex-1 flex-col rounded-xl border border-stat-card-border bg-surface p-internal-lg font-brand',
        className,
      )}
    >
      <span className="text-stat-value" aria-hidden>
        {emoji}
      </span>
      <span className="truncate text-stat-value text-on-surface">{value}</span>
      <span className="text-label-sm text-on-surface-medium">{caption}</span>
    </div>
  );
}
